import { Button } from '@/components/ui/Button'
import { cn } from '@/lib/cn'
import styles from './ConfirmSheetFooter.module.css'

type ConfirmSheetFooterProps = {
  cancelLabel?: string
  confirmLabel: string
  onCancel: () => void
  onConfirm: () => void
  confirmDisabled?: boolean
  confirmLoading?: boolean
  cancelDisabled?: boolean
  className?: string
}

export function ConfirmSheetFooter({
  cancelLabel = 'انصراف',
  confirmLabel,
  onCancel,
  onConfirm,
  confirmDisabled = false,
  confirmLoading = false,
  cancelDisabled = false,
  className,
}: ConfirmSheetFooterProps) {
  return (
    <div className={cn(styles.footer, className)}>
      <Button
        variant="outline"
        className={styles.button}
        disabled={cancelDisabled}
        onClick={onCancel}
      >
        {cancelLabel}
      </Button>
      <Button
        className={styles.button}
        loading={confirmLoading}
        disabled={confirmDisabled}
        onClick={onConfirm}
      >
        {confirmLabel}
      </Button>
    </div>
  )
}
